"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _utils = require("../../../../../common/utils");

var _TrafficListItem = _interopRequireDefault(require("./TrafficListItem"));

var _SetDueDateModal = _interopRequireDefault(require("./SetDueDateModal"));

require("../styles/traffic-list.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SHOW_VIDEO_ON_HOLD_STATUSES = ['EDITING', 'PENDING_MASTER', 'ON_HOLD'];

function pushToOutputUrl(output, action, history) {
  return function () {
    if (action === 'BRIEF') {
      return void history.rootPush("/video-tool/builder/".concat(output.videoId));
    }

    if (action === 'COMPLETED') {
      return void history.rootPush("/video-tool/complete/".concat(output.videoId, "/").concat(output.outputId));
    }

    return void history.rootPush("/review/".concat(output.videoId, "/").concat(output.outputId));
  };
}

var TrafficList = /*#__PURE__*/function (_Component) {
  _inherits(TrafficList, _Component);

  var _super = _createSuper(TrafficList);

  function TrafficList() {
    var _this;

    _classCallCheck(this, TrafficList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      versionId: void 0,
      outputId: void 0
    });

    _defineProperty(_assertThisInitialized(_this), "openModal", (0, _lodash.default)(function (_ref) {
      var versions = _ref.versions,
          outputId = _ref.outputId,
          latestVersion = _ref.latestVersion;
      return function () {
        var currentVersion = (0, _utils.getCurrentVersion)({
          versions: versions,
          latestVersion: latestVersion
        });

        if (!currentVersion || !currentVersion.versionId) {
          return;
        }

        _this.setState({
          versionId: currentVersion.versionId,
          outputId: outputId
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "gotoVideo", (0, _lodash.default)(function (videoId) {
      return function () {
        var history = _this.props.history;
        return void history.push("video/".concat(videoId));
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "onHoldAction", (0, _lodash.default)(function (outputId) {
      return (/*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var _this$props, setOnHoldDate, onHoldActionChange, _yield$setOnHoldDate, data, error, _data$setOnHold, status, onHoldDate, versions;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this$props = _this.props, setOnHoldDate = _this$props.setOnHoldDate, onHoldActionChange = _this$props.onHoldActionChange;
                  _context.next = 3;
                  return setOnHoldDate({
                    outputId: outputId
                  });

                case 3:
                  _yield$setOnHoldDate = _context.sent;
                  data = _yield$setOnHoldDate.data;
                  error = _yield$setOnHoldDate.error;

                  if (!(!data || !data.setOnHold || error)) {
                    _context.next = 8;
                    break;
                  }

                  return _context.abrupt("return");

                case 8:
                  _data$setOnHold = data.setOnHold, status = _data$setOnHold.status, onHoldDate = _data$setOnHold.onHoldDate, versions = _data$setOnHold.versions;
                  onHoldActionChange({
                    outputId: outputId,
                    status: status,
                    onHoldDate: onHoldDate,
                    versions: versions
                  });

                case 10:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))
      );
    }));

    _defineProperty(_assertThisInitialized(_this), "gotoBrief", (0, _lodash.default)(function (videoId) {
      return function () {
        var history = _this.props.history;
        return void history.rootPush("video-tool/builder/".concat(videoId));
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "moveToBuilding", (0, _lodash.default)(function (videoId) {
      return (/*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          var _this$props2, moveToBuilding, onMoveToBuilding, _yield$moveToBuilding, data, error;

          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _this$props2 = _this.props, moveToBuilding = _this$props2.moveToBuilding, onMoveToBuilding = _this$props2.onMoveToBuilding;
                  _context2.next = 3;
                  return moveToBuilding({
                    videoId: videoId
                  });

                case 3:
                  _yield$moveToBuilding = _context2.sent;
                  data = _yield$moveToBuilding.data;
                  error = _yield$moveToBuilding.error;

                  if (!(!data || !data.moveToBuilding || error)) {
                    _context2.next = 8;
                    break;
                  }

                  return _context2.abrupt("return");

                case 8:
                  onMoveToBuilding(videoId);

                case 9:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }))
      );
    }));

    _defineProperty(_assertThisInitialized(_this), "ghostUser", function (user, orgAlais) {
      var ghostStart = _this.props.ghostStart;
      return (0, _utils.ghostUserInvoker)({
        ghostStart: ghostStart,
        user: user,
        orgAlais: orgAlais
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderListItem", (0, _lodash.default)(function (output) {
      var _this$props3 = _this.props,
          updateOutput = _this$props3.updateOutput,
          editors = _this$props3.editors,
          history = _this$props3.history,
          getCaptions = _this$props3.getCaptions,
          getFormattedAddon = _this$props3.getFormattedAddon,
          orgPermissions = _this$props3.orgPermissions;
      var goToAction = output.status.name === 'DRAFT' ? _this.gotoBrief : _this.gotoVideo;
      var goToVideo = goToAction(output.videoId);

      var onHoldAction = _this.onHoldAction(output.outputId);

      var allowSetDueDate = (0, _commonReact.hasPermission)('INTERNAL', orgPermissions) && output.status.name !== 'DRAFT' && output.status.name !== 'APPROVED';
      var popupActions = [{
        action: goToVideo,
        label: 'View Details'
      }, {
        action: pushToOutputUrl(output, 'BRIEF', history),
        label: 'VIEW VIDEO BRIEF'
      }, allowSetDueDate ? {
        action: _this.openModal(output),
        label: 'SET DUE DATE'
      } : void 0, output.status.name !== 'DRAFT' ? {
        action: pushToOutputUrl(output, 'HISTORY', history),
        label: 'VIEW VERSION HISTORY'
      } : void 0, output.status.name === 'APPROVED' ? {
        action: pushToOutputUrl(output, 'COMPLETED', history),
        label: 'VIEW COMPLETED VIDEO'
      } : void 0, output.isMaster && output.status.name === 'EDITING' ? {
        action: _this.moveToBuilding(output.videoId),
        label: 'MOVE TO BUILDING'
      } : void 0, SHOW_VIDEO_ON_HOLD_STATUSES.includes(output.status.name) ? {
        action: onHoldAction,
        label: output.onHoldDate ? 'REMOVE ON-HOLD' : 'SET VIDEO ON-HOLD'
      } : void 0].filter(Boolean);
      return (/*#__PURE__*/_react.default.createElement(_TrafficListItem.default, {
          output: output,
          gotoVideo: goToVideo,
          updateOutput: updateOutput,
          popupActions: popupActions,
          editors: editors,
          getCaptions: getCaptions,
          getFormattedAddon: getFormattedAddon,
          toGhostUser: _this.ghostUser
        })
      );
    }));

    _defineProperty(_assertThisInitialized(_this), "closeModal", function () {
      _this.setState({
        versionId: void 0,
        outputId: void 0
      });
    });

    return _this;
  }

  _createClass(TrafficList, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          versionId = _this$state.versionId,
          outputId = _this$state.outputId;
      var _this$props4 = this.props,
          history = _this$props4.history,
          outputs = _this$props4.outputs,
          loading = _this$props4.loading,
          onFiltersChange = _this$props4.onFiltersChange,
          onDueDateChange = _this$props4.onDueDateChange,
          loadMoreResults = _this$props4.loadMoreResults,
          totalResults = _this$props4.totalResults,
          getTrafficRef = _this$props4.getTrafficRef,
          onChangeQueueType = _this$props4.onChangeQueueType,
          queueTypeIndex = _this$props4.queueTypeIndex;
      return (/*#__PURE__*/_react.default.createElement("div", {
          className: "traffic-list"
        }, /*#__PURE__*/_react.default.createElement(_SetDueDateModal.default, {
          onDueDateChange: onDueDateChange,
          onClose: this.closeModal,
          versionId: versionId,
          outputId: outputId
        }), /*#__PURE__*/_react.default.createElement(_uiKit.List, {
          onFiltersChange: onFiltersChange,
          listKey: "outputId",
          history: history,
          data: outputs,
          loading: loading,
          renderListItem: this.renderListItem,
          loadMoreResults: loadMoreResults,
          totalResults: totalResults,
          getInfiniteScrollParent: getTrafficRef,
          filtersRightAddon: /*#__PURE__*/_react.default.createElement(_uiKit.Tabs, {
            updateSelectedTabIndex: onChangeQueueType,
            initialIndex: queueTypeIndex
          }, /*#__PURE__*/_react.default.createElement("div", {
            title: "MY QUEUE"
          }), /*#__PURE__*/_react.default.createElement("div", {
            title: "GLOBAL QUEUE"
          }))
        }))
      );
    }
  }]);

  return TrafficList;
}(_react.Component);

exports.default = TrafficList;